import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { getNormalizedTrackingStatusOptions } from './helpers'

const NormalizedTrackingStatusSelector = ({ onChange, value = [] }) => {
  const { t } = useTranslation()

  const handleChange = e => {
    onChange(e.target.value)
  }

  const options = getNormalizedTrackingStatusOptions()

  return (
    <ComboBox
      value={value || []}
      label={t('Último estado de seguimiento')}
      fullWidth
      multiple
      handleChange={handleChange}
      menuItems={options.map(option => ({ label: t(option.label), value: option.value }))}
      placeholder={t('Todos')}
    />
  )
}

export default NormalizedTrackingStatusSelector
